import styles from "./retail.module.css";

import { useState, useEffect } from "react";

import { useQuery, useMutation } from "@apollo/client";

import { gql } from "@apollo/client";

import { useTranslation } from "react-i18next";

import { MdOutlineUpdate } from "react-icons/md";

import Breadcrumbs from "../../../../Components/Dashboard/Breadcrumbs";

import Tabs from "../../../../Components/Dashboard/Global/Tabs";

import Fieldset from "../../../../Components/Dashboard/Global/Forms/Fieldset";

import { Input } from "../../../../Components/Dashboard/Global/Forms/Inputs_Spread";

import ComponentLoader from "../../../../Components/Dashboard/Loaders/ComponentLoader";

const QUERY_RETAIL_MARKUP = gql`
    query GetRetailMarkup {
        adminVisualMarkup {
            id
            deleted
            markupPercent
            updatedAt
        }
    }
`;

const UPDATE_RETAIL_MARKUP = gql`
    mutation UpdateRetailMarkup($id: Int, $markupPercent: Int!) {
        adminUpdateVisualMarkup(input: {
            id: $id
            markupPercent: $markupPercent
        }) {
            visualMarkup {
                id
                markupPercent
                updatedAt
            }
        }
    }
`;

export default function RetailMarkup () {
    const { t } = useTranslation();

    const { data, loading, error, refetch } = useQuery(QUERY_RETAIL_MARKUP);

    const [updateMarkup, { loading: updateLoading }] = useMutation(UPDATE_RETAIL_MARKUP);

    const [formData, setFormData] = useState({
        retailMarkupPercent: ""
    });

    const [updatedAt, setUpdatedAt] = useState(null);

    useEffect(() => {
        if (data?.adminVisualMarkup) {
            setFormData({
                retailMarkupPercent: data.adminVisualMarkup.markupPercent
            });
            setUpdatedAt(data.adminVisualMarkup.updatedAt);
        }
    }, [data]);

    const handleChange = (e) => {
        const { value } = e.target;
        setFormData({ retailMarkupPercent: value === "" ? "" : value });
    };

    const handleSave = async (e) => {
        e.preventDefault();

        if (formData.retailMarkupPercent === "" || formData.retailMarkupPercent === null) {
            return;
        }

        try {
            const response = await updateMarkup({
                variables: {
                    id: data?.adminVisualMarkup?.id || null,
                    markupPercent: parseInt(formData.retailMarkupPercent, 10)
                }
            });

            const saved = response.data?.adminUpdateVisualMarkup?.visualMarkup;

            if (saved) {
                setFormData({ retailMarkupPercent: saved.markupPercent });
                setUpdatedAt(saved.updatedAt);
                await refetch();
            }
        } catch (err) {
            console.error("Error updating retail markup:", err);
        }
    };

    if (error) {
        return (
            <section className="markups">
                <Breadcrumbs />
                <p>{ t("error") || "Failed to load retail markup." }</p>
            </section>
        );
    }

    return (
        <section className="markups">
            <Breadcrumbs />

            <Tabs data={[
                { name: t("Default"), uri: `/app/shop/markups/global/default` },
                { name: t("Group A"), uri: `/app/shop/markups/global/groupA` },
                { name: t("Group B"), uri: `/app/shop/markups/global/groupB` },
                { name: t("Group C"), uri: `/app/shop/markups/global/groupC` },
                { name: t("Retail"), uri: `/app/shop/markups/retail` }
            ]} />

            <form className={styles.container} onSubmit={handleSave}>
                {loading ? (
                    <ComponentLoader />
                ) : (
                    <div className="markup_content global">
                        <Fieldset legend={t("retail_markup")} description={t("retail_markup_description")}>
                            <Input
                                type="number"
                                name="retailMarkupPercent"
                                disabled={loading || updateLoading}
                                value={formData.retailMarkupPercent}
                                action={handleChange}
                            />

                            {updatedAt && (
                                <small>
                                    {t("last_updated", {
                                        date: new Date(updatedAt).toLocaleString().replace(/\//g, ".")
                                    })}
                                </small>
                            )}
                        </Fieldset>
                    </div>
                )}

                <button disabled={loading || updateLoading}>
                    <MdOutlineUpdate />
                    <span>{ t("save") }</span>
                </button>
            </form>
        </section>
    );
}
